var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.addToHomescreen)?_c('section',{staticClass:"wcc section add-to-homescreen"},[_c(_vm.component,{tag:"component"})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }